import { MIXTURE, POLIMER, SUBSTANCE } from 'utils/constants/coreConstants';

export default {
  orderBy: {
    what: ['name'],
    how: ['asc']
  },
  sanitizers: {
    type: value => {
      switch (value) {
        case 'substância':
        case 'substancia':
        case 'Substancia':
        case 'Substância':
          return SUBSTANCE;
        case 'Mistura':
        case 'mistura':
          return MIXTURE;
        case 'Polimero':
        case 'polímero':
        case 'polimero':
        case 'Polímero':
          return POLIMER;
        default:
          return value;
      }
    },
    hazardous: value => {
      switch (value) {
        case 'sim':
        case 'Sim':
        case true:
        case 'True':
        case 'true':
          return true;
        case 'Não':
        case 'não':
        case 'nao':
        case 'Nao':
        case  null:
        case  false:
        case  'False':
        case  'false':
          return false;
        case 'true':
        case 'false':
          return JSON.parse(value);
        default:
          return false;
      }
    },
    cas: value => {
      if (!value) {
        return [];
      }
      if (value[0] === '[') {
        return JSON.parse(value);
      } else {
        let n = 0;
        const trimValue = value.replace(/ /g, '');
        if (trimValue.indexOf(',') === -1) {
          if (trimValue === '-') {
            return [];
          } else {
            return [trimValue];
          }
        } else {
          const valueArray = [];
          let nextn = 0;
          while (nextn !== -1) {
            nextn = trimValue.indexOf(',', n);
            nextn === -1 ?
              valueArray.push(trimValue.slice(n)) :
              valueArray.push(trimValue.slice(n, nextn));
            n = nextn + 1;
          }
          return valueArray;
        }
      }
    },

    ec: value => {
      if (!value) {
        return [];
      }
      if (value[0] === '[') {
        return JSON.parse(value);
      } else {
        let n = 0;
        const trimValue = value.replace(/ /g, '');
        if (trimValue.indexOf(',') === -1) {
          if (trimValue === '-') {
            return [];
          } else {
            return [trimValue];
          }
        } else {
          const valueArray = [];
          let nextn = 0;
          while (nextn !== -1) {
            nextn = trimValue.indexOf(',', n);
            nextn === -1 ?
              valueArray.push(trimValue.slice(n)) :
              valueArray.push(trimValue.slice(n, nextn));
            n = nextn + 1;
          }
          return valueArray;
        }
      }
    }
    // `substances` and `mixtures` were sanitized here too, to turn the stored
    // fraction into the percentage every screen showed. A raw material no
    // longer carries either; the rule moved, unchanged, to
    // `reducingOptions/mixtures`, which is where those rows arrive now.
  }
};
